export default __webpack_public_path__ + "ece0a8207e4665622bed4515811c05c7.svg";